import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import Icon from '@material-ui/core/Icon'

import Wrapper from '../../components/Wrapper'
import Header from '../../components/Header'
import Body from '../../components/Body'
import Footer from '../../components/Footer'
import TopBar from '../../components/TopBar'
import SubmitButton from '../../components/SubmitButton'
import TrueMoney from '../../assets/motor/logo-truemoney_3.png'
import TruePattern from '../../assets/motor/truepattern.png'
import moment from 'moment'

import _ from 'lodash'
import numeral from 'numeral'

const fontDefault = {
  fontFamily: 'thonburiregular',
  fontStyle: 'normal',
}

const styles = {
  topBarImg: {
    height: '28px',
  },
  title: {
    ...fontDefault,
    color: '#0e162c',
    fontSize: '18px',
    textAlign: 'center',
    marginBottom: '3px',
    fontWeight: 'bold',
  },
  price: {
    ...fontDefault,
    fontSize: '36px',
    color: '#233987',
    textAlign: 'center',
    marginTop: '0px',
  },
  container: {
    margin: '16px',
  },
  containerInside: {
    marginTop: '16px',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  text: {
    ...fontDefault,
    color: '#0e162c',
    fontSize: '14px',
  },
  textSan: {
    ...fontDefault,
    fontFamily: 'San Francisco Text',
    color: '#0e162c',
    fontSize: '14px',
  },
  textFade: {
    ...fontDefault,
    color: '#878b96',
    fontSize: '14px',
  },
  textSanFade: {
    ...fontDefault,
    fontFamily: 'San Francisco Text',
    color: '#878b96',
    fontSize: '14px',
  },
  textBold: {
    ...fontDefault,
    color: '#0e162c',
    fontWeight: 'bold',
    fontSize: '16px',
  },
  textSanBold: {
    ...fontDefault,
    fontFamily: 'San Francisco Text',
    color: '#0e162c',
    fontSize: '16px',
    fontWeight: 'bold',
  },
  line: {
    borderTop: '1px solid #c3c5cb',
    borderBottom: 'none',
    marginTop: '16px',
    marginBottom: '16px',
    opacity: '0.5',
  },
  headDesc: {
    ...fontDefault,
    fontSize: '12px',
    color: '#878b96',
    textAlign: 'center',
    marginBottom: '0px',
    marginTop: '0px',
  },
}

class VerifyOTP extends Component {
  goToNextPage = () => {
    const {
      history: { push },
    } = this.props
    const { callbackVersion, currentProduct } = this.props
    if (callbackVersion === 2) {
      if (currentProduct === 'C') {
        push('/select-package')
      } else if (currentProduct === 'V') {
        push('/select-car-model')
      } else {
        push('/home')
      }
    } else {
      push('/home')
    }
  }

  componentDidMount = () => {
    const {
      currentProduct,
      selectPrice,
      carBrand,
      carModel,
      carYear,
      insuranceClass,
      userInput,
    } = this.props
    const mixpanel = _.get(window, 'mixpanel', undefined)
    const currentPackage = _.get(userInput, 'currentPackage', {})
    if (!!mixpanel) {
      const orderSuccessData = _.get(userInput, 'orderSuccessData', {})
      const transactionData = _.get(orderSuccessData, 'transaction', {})
      mixpanel.track('Insurance Car Success', {
        'Insurance type':
          currentProduct === 'V'
            ? 'Voluntary Motor Insurance'
            : 'Compulsory Motor Insurance',
        'Insurance class': insuranceClass,
        Amount: selectPrice,
        'Car make': carBrand,
        'Car model': _.get(carModel, 'label', ''),
        'Car registration year': carYear,
      })
      mixpanel.people.set({
        'Last bought car insurance date': new Date(
          _.get(transactionData, 'transaction_at', new Date().toString())
        ).toLocaleString('th-TH'),
      })
    }
    const dataLayer = _.get(window, 'dataLayer', undefined)
    if (!!dataLayer) {
      const orderSuccessData = _.get(userInput, 'orderSuccessData', {})
      const transactionData = _.get(orderSuccessData, 'transaction', {})
      const orderSuccessDataPolicy = _.get(
        orderSuccessData,
        'policy_product',
        []
      )
      dataLayer.push({
        event: 'purchase', // Required
        currencyCode: 'THB',
        ecommerce: {
          purchase: {
            actionField: {
              id: _.get(transactionData, 'resp_transaction_id', ''),
              revenue: selectPrice,
              tax: '0.00',
              shipping: '0.00',
              coupon: '',
            },
            products: orderSuccessDataPolicy.map(x => {
              return {
                id: x.id,
                name:
                  x.product_sub_type === 'vmi'
                    ? parseInt(_.get(currentPackage, 'risk', 0)) === 5
                      ? 'ประกันรถยนต์ชั้น 2+'
                      : parseInt(_.get(currentPackage, 'risk', 0)) === 5
                      ? 'ประกันรถยนต์ชั้น 1'
                      : 'ประกันรถยนต์ชั้น 3'
                    : 'พ.ร.บ.',
                category:
                  x.product_sub_type === 'vmi'
                    ? 'Voluntary Motor Insurance'
                    : 'Compulsory Motor Insurance',
                brand: 'Bangkok Insurance',
                variant:
                  x.product_sub_type === 'vmi'
                    ? parseInt(_.get(currentPackage, 'risk', 0)) === 5
                      ? 'ประกันรถยนต์ชั้น 2+'
                      : parseInt(_.get(currentPackage, 'risk', 0)) === 5
                      ? 'ประกันรถยนต์ชั้น 1'
                      : 'ประกันรถยนต์ชั้น 3'
                    : 'พ.ร.บ.',
                price: x.package_price, // required
                quantity: 1, // required
              }
            }),
          },
        },
      })
    }
  }

  render() {
    const { classes, userInput, currentProduct, selectPrice } = this.props
    const { isVMIIncludeCMI } = userInput
    const currentPackage = _.get(userInput, 'currentPackage', {})
    const effDate = _.get(userInput, 'effDate', '0001-01-01') || '0001-01-01'
    const startEffDate = moment(effDate).format('YYYY-MM-DD')
    const endEffDate = moment(effDate)
      .add(1, 'years')
      .format('YYYY-MM-DD')
    const dateFromTo = startEffDate + ' - ' + endEffDate

    const orderSuccessData = _.get(userInput, 'orderSuccessData', {})
    const transactionData = _.get(orderSuccessData, 'transaction', {})
    const policyNumberArray = []
    const orderSuccessDataPolicy = _.get(orderSuccessData, 'policy_product', [])
    orderSuccessDataPolicy.forEach(policy => {
      policyNumberArray.push(_.get(policy, 'policy_number', ''))
    })
    const policyNumber = policyNumberArray.map(x => {
      return (
        <p
          style={{
            ...fontDefault,
            marginTop: '0px',
            marginBottom: '0px',
            fontSize: '14px',
            color: '#0e162c',
          }}
        >
          {x}
        </p>
      )
    })
    return (
      <Wrapper>
        <Body style={{ backgroundImage: 'url(' + TruePattern + ')' }}>
          <div className={classes.container}>
            <div style={{ marginLeft: '30px', marginRight: '30px' }}>
              <Grid container>
                <Grid justify="center" container style={{ marginTop: '10px' }}>
                  <Icon
                    className={classes.icon}
                    fontSize="large"
                    style={{ color: '#64cbac', fontSize: '72px' }}
                  >
                    check_circle
                  </Icon>
                </Grid>
              </Grid>
              <p className={classes.title}>ทำรายการสำเร็จ </p>
              <p className={classes.headDesc} style={{ marginTop: '3px' }}>
                เลขที่อ้างอิง:{' '}
                {_.get(transactionData, 'resp_transaction_id', '')}
              </p>
              <p className={classes.headDesc}>
                {new Date(
                  _.get(
                    transactionData,
                    'transaction_at',
                    new Date().toString()
                  )
                ).toLocaleString('th-TH')}
              </p>
              <p className={classes.headDesc} style={{ marginTop: '8px' }}>
                กรุงเทพประกันภัยจะส่งกรมธรรม์ให้คุณ ภายใน 20 นาที ทางอีเมล{' '}
                {_.get(userInput, 'email', '')}
              </p>
            </div>
            <div className={classes.containerInside}>
              <div className={classes.item}>
                <span className={classes.text}>ชำระสำหรับ</span>
                <span className={classes.text}>
                  {currentProduct === 'V'
                    ? parseInt(_.get(currentPackage, 'risk', 0)) === 5
                      ? !isVMIIncludeCMI
                        ? 'ประกันชั้น 2+'
                        : 'ประกันชั้น 2+ และ พ.ร.บ.'
                      : parseInt(_.get(currentPackage, 'risk', 0)) === 1
                      ? !isVMIIncludeCMI
                        ? 'ประกันชั้น 1'
                        : 'ประกันชั้น 1 และ พ.ร.บ.'
                      : !isVMIIncludeCMI
                      ? 'ประกันชั้น 3'
                      : 'ประกันชั้น 3 และ พ.ร.บ.'
                    : 'พ.ร.บ.'}
                </span>
              </div>
              <div className={classes.item}>
                <span className={classes.text}>ช่องทางชำระเงิน</span>
                <span className={classes.text}>ทรูมันนี่ วอลเล็ท</span>
              </div>
              <div
                className={classes.item}
                style={{ alignItems: 'flex-start' }}
              >
                <span className={classes.text}>หมายเลขกรมธรรม์</span>
                <span className={classes.text}>{policyNumber}</span>
              </div>
              <div className={classes.item}>
                <span className={classes.text}>วันที่คุ้มครอง</span>
                <span className={classes.text}>{dateFromTo}</span>
              </div>
              <div className={classes.item}>
                <span className={classes.text}>รับเงินคืนช่องทางวอลเล็ท</span>
                <span className={classes.textSan}>
                  ฿{' '}
                  {numeral(
                    parseFloat(_.get(currentPackage, 'cashback_value', 0)) +
                      (isVMIIncludeCMI
                        ? parseFloat(
                            _.get(currentPackage, 'cashback_value_cmi', 0)
                          )
                        : 0)
                  ).format('0,0.00')}
                </span>
              </div>
              <hr className={classes.line} />
              <div className={classes.item}>
                <span className={classes.text}>ยอดเรียกทำรายการ</span>
                <span className={classes.textSan}>
                  ฿ {numeral(selectPrice).format('0,0.00')}
                </span>
              </div>
              {currentProduct === 'V' ? (
                !isVMIIncludeCMI ? (
                  <div>
                    <div className={classes.item}>
                      <span className={classes.textFade}>ประกันรถยนต์</span>
                      <span className={classes.textSanFade}>
                        ฿{' '}
                        {numeral(
                          _.get(currentPackage, 'total_prem_vol', 0) -
                            parseFloat(
                              _.get(currentPackage, 'discount_price', 0)
                            )
                        ).format('0,0.00')}
                      </span>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className={classes.item}>
                      <span className={classes.textFade}>ประกันรถยนต์</span>
                      <span className={classes.textSanFade}>
                        ฿{' '}
                        {numeral(
                          _.get(currentPackage, 'total_prem_vol', 0) -
                            parseFloat(
                              _.get(currentPackage, 'discount_price', 0)
                            )
                        ).format('0,0.00')}
                      </span>
                    </div>
                    <div className={classes.item}>
                      <span className={classes.textFade}>พ.ร.บ.</span>
                      <span className={classes.textSanFade}>
                        ฿{' '}
                        {numeral(
                          _.get(currentPackage, 'total_prem_comp', 0)
                        ).format('0,0.00')}
                      </span>
                    </div>
                  </div>
                )
              ) : (
                <div>
                  <div className={classes.item}>
                    <span className={classes.textFade}>พ.ร.บ.</span>
                    <span className={classes.textSanFade}>
                      ฿ {numeral(selectPrice).format('0,0.00')}
                    </span>
                  </div>
                </div>
              )}
              <hr className={classes.line} />
              <div className={classes.item}>
                <span className={classes.textBold}>ยอดชำระทั้งหมด</span>
                <span className={classes.textSanBold}>
                  ฿ {numeral(selectPrice).format('0,0.00')}
                </span>
              </div>
              <div className={classes.item}>
                <span className={classes.textFade}>
                  หมายเหตุ: *หากไม่ได้รับอีเมลภายใน 20 นาที
                  กรุณาติดต่อบริษัทกรุงเทพประกันภัย 0 2285 8888
                </span>
              </div>
            </div>
          </div>
        </Body>
        <Footer>
          <SubmitButton onClick={this.goToNextPage}>กลับ</SubmitButton>
        </Footer>
        <Header>
          <TopBar
            close={() => {
              window.location.replace('ascendmoney://closewebview')
            }}
          >
            <img
              className={classes.topBarImg}
              alt="True Money"
              src={TrueMoney}
            />
          </TopBar>
        </Header>
      </Wrapper>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    userInput: _.get(state, 'motor.userInput', {}),
    currentProduct: _.get(state, 'motor.userInput.currentProduct', ''),
    selectPrice: _.get(state, 'motor.userInput.selectPrice', 0),
    carBrand: _.get(state, 'motor.userInput.carBrand', ''),
    carModel: _.get(state, 'motor.userInput.carModel', ''),
    carYear: _.get(state, 'motor.userInput.carYear', ''),
    insuranceClass: _.get(state, 'motor.userInput.insuranceClass', ''),
    callbackVersion: _.get(state, 'motor.userInput.callbackVersion', 1),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {}
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(VerifyOTP))
